<template>
  <div class="row">
    <div class="col" @click="clicked">
      <label v-if="label">{{label}}</label>
      <multi-list-select
        v-if="multiple"
        :list="list || []"
        :selectedItems="value || []"
        :option-value="optionValue"
        :option-text="_optionLabel"
        :placeholder="placeholder || defaultPlaceholder"
        @searchchange="searchchange"
        :filterPredicate="alwaysTrueFilterPredicate"
        @select="select"
      ></multi-list-select>
      <model-list-select
        v-else
        :list="list || []"
        v-model="value"
        :option-value="optionValue"
        :option-text="_optionLabel"
        :placeholder="placeholder || defaultPlaceholder"
        @searchchange="searchchange"
        :filterPredicate="alwaysTrueFilterPredicate"
        @select="select"
      />
    </div>

    <div v-if="loading" class="col-auto ml-3 mt-3">
      <loading-animation />
    </div>
  </div>
</template>

<script>
import { LoadingAnimation } from '@/components/loaders';
import { MultiListSelect } from 'vue-search-select'
import { ModelListSelect } from 'vue-search-select'
import { httpClient } from '@/service'
import shared from '@/shared/shared'

export default {
  name: 'lazy-select',
  components: { LoadingAnimation, ModelListSelect, MultiListSelect },

  props: {
    label: {
      type: String
    },
    multiple: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String
    },
    optionLabel: {
      type: String,
      default: 'name'
    },
    optionValue: {
      type: String,
      default: 'id'
    },
    value: {
      type: [Object, Array],
      required: true
    },
    resourceName: {
      type: String,
      required: true
    },
    pageSize: {
      type: Number,
      default: 10
    },
    feminine: {
      type: Boolean,
      default: false
    },
    includeAllOption: {
      type: Boolean,
      default: true
    },
    conditions: {
      type: Array
    },
    refSize: {
      type: Number
    },
    loadOnStart: {
      type: Boolean,
      default: false
    },
    loadOnFirstClick: {
      type: Boolean,
      default: true
    },
    shouldConcatRefToOptionLabel: {
      type: Boolean,
      default: true
    }
    // fieldNames: {
    //   type: Array,
    //   default: () => ['ref', 'name']
    // }
  },

  data() {
    return {
      loading: false,
      searchTimeout: undefined,
      list: [],
      defaultPlaceholder: 'Digite para pesquisar',
      isFirstClick: true
    }
  },

  mounted() {
    if (this.loadOnStart) {
      this.searchchange();
    }
  },

  computed: {
    allLabel() {
      return this.feminine ? 'Todas' : 'Todos';
    },

    _optionLabel() {
      return this.optionLabel.replace(/\./g, '_');
    }
  },

  methods: {
    clicked(event) {
      event.stopPropagation();
      if (!this.isFirstClick || !this.loadOnFirstClick) return;
      this.isFirstClick = false;
      this.searchchange();
    },

    alwaysTrueFilterPredicate() {
      return true;
    },

    getCondition(searchText) {
      let temp = {
        logicalOperator: 'OR'
      };

      if (this.conditions && this.conditions.length) {
        temp.conditions = this.conditions;
      } else {
        temp.conditions = [
          {
            field: this.optionLabel,
            conditionalOperator: 'LIKE_START',
            value: searchText
          },
          {
            field: 'ref',
            conditionalOperator: 'LIKE_END',
            value: this.refSize ? shared.mountReduzidoFilter(searchText, this.refSize) : searchText
          },
        ];
      }

      return {
        conditions: [temp]
      };
    },

    searchchange(searchText) {
      if (!this.loading) {
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
        }

        this.searchTimeout = setTimeout(() => {
          this.loading = true

          if (searchText && searchText.length) {
            httpClient
            .post(`${process.env.VUE_APP_API_URL}${this.resourceName}/condition?page=${0}&size=${this.pageSize}`, this.getCondition(searchText))
            .then(this.itemsSearched)
            .catch(this.handleItemSearchedError);
          } else {
            httpClient
            .get(`${process.env.VUE_APP_API_URL}${this.resourceName}/?page=${0}&size=${this.pageSize}`)
            .then(this.itemsSearched)
            .catch(this.handleItemSearchedError);
          }
        }, 500);
      }
    },

    itemsSearched({ data }) {
      this.loading = false;
      let idKey = this.optionValue || 'id';

      this.list = (data.data.content || []).map(row => {
        row[this._optionLabel] = shared.getNestedProperty(row, this.optionLabel);

        if (this.shouldConcatRefToOptionLabel && row.ref) {
          row[this._optionLabel] = row.ref + ' - ' + row[this._optionLabel];
        }

        return row;
      });

      if (!this.multiple && this.includeAllOption) {
        let allOption = {};
        allOption[idKey] = null;
        allOption[this._optionLabel] = this.allLabel;
        this.list.unshift(allOption);
      }

      let selectedRows = this.multiple ? this.value : [ this.value ];
      selectedRows.forEach(row => {
        if (row[idKey] && !this.list.find(r => r[idKey] === row[idKey])) {
          this.list.push(row);
        }
      });
    },

    handleItemSearchedError(error) {
      this.loading = false
      if (error.message) {
        this.$notify.error(error)
      }
    },

    select(newModelValue) {
      if (newModelValue && this.optionValue) {
        let selectedRows = this.multiple ? newModelValue : [ newModelValue ];

        selectedRows = selectedRows.map(row => {
          let tempRow = {};
          tempRow[this.optionValue] = row[this.optionValue];

          if (this._optionLabel) {
            tempRow[this._optionLabel] = row[this._optionLabel];
          }

          return tempRow;
        });

        newModelValue = this.multiple ? selectedRows : selectedRows[0];
      }

      this.$emit('input', newModelValue);
    }
  }
}
</script>

<style scoped>
</style>
